export default "__VITE_ASSET__32KP$BYf__"